__turbopack_context__.v({
  "carousel": "OfGCgG_carousel",
  "container": "OfGCgG_container",
  "grid": "OfGCgG_grid",
  "hidden": "OfGCgG_hidden",
  "nextButton": "OfGCgG_nextButton",
  "scrollArea": "OfGCgG_scrollArea",
});
